
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import theme from './theme';


import Dashboard from './pages/Dashboard';
import Login from './pages/Login';

import Categories from './pages/Categories';
import Products from './pages/Products';
import Business from './pages/Business';
import Layout from './components/Layout';
import User from './pages/User';
import PlaceOrder from './pages/PlaceOrder';
import Orders from './pages/Orders';
import FAQ from './pages/FAQ';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Admins from './pages/Admins';
import TemplateCategories from './pages/TemplateCategories'
import Template from './pages/Template'
import SiteLayout from './site/SiteLayout';
import Home from './site/pages/Home';
import Templates from './site/pages/Templates';
import TemplateDemo from './site/pages/TemplateDemo';
import { getToken } from './auth';

function RequireAuth({ children }) {
  return getToken() ? children : <Navigate to="/login" replace />;
}

// A signed-in admin who opens /login goes straight to the dashboard.
function RedirectIfAuthed({ children }) {
  return getToken() ? <Navigate to="/dashboard" replace /> : children;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
      <Router>
        <Routes>
          {/* Public website */}
          <Route element={<SiteLayout />}>
            <Route index element={<Home />} />
            <Route path="templates" element={<Templates />} />
          </Route>
          <Route path="/templates/:slug" element={<TemplateDemo />} />

          {/* Admin */}
          <Route path="/login" element={<RedirectIfAuthed><Login /></RedirectIfAuthed>} />
          <Route element={<RequireAuth><Layout /></RequireAuth>}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path='templateCategory' element={<TemplateCategories/>}/>
            <Route path='template' element={<Template/>}/>
            <Route path="businesses" element={<Business />} />
            <Route path="categories" element={<Categories />} />
            <Route path="products" element={<Products />} />
            <Route path="users" element={<User />} />
            <Route path="place-order" element={<PlaceOrder />} />
            <Route path="orders" element={<Orders />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="admins" element={<Admins />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
